var documentReady = function () {
    console.log('DOM Loaded');

    // Zmienna globalna przenosząca tłumaczenia. Konfigurowalna w config.php.
    // console.log(i18n);

    // RxJS working
    // fromEvent(document, "click").subscribe(() => {
    //   test();
    // });
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
